import { ReactNode } from 'react';
import { Button } from '@sweep-io/sweep-design';
import usePermission from '../permissions/usePermission';
import { Permission } from '@server/permissions';
import RestrictedTooltip from '../permissions/RestrictedTooltip';
import EmptyState from './EmptyState';
import { ButtonSize } from '@sweep-io/sweep-design/dist/components/Button/types';

const EmptyStateWithButton = ({
  image,
  line1,
  line2,
  titleLine,
  onClick,
  permissionString,
  notAllowedTitle,
  forceDisallowTitle,
  buttonDisabled,
  buttonSize = 'medium',
  dataTestId,
}: {
  image: ReactNode;
  titleLine?: string;
  line1?: string;
  line2?: string;
  onClick: () => void;
  permissionString: Permission[];
  notAllowedTitle: string;
  forceDisallowTitle?: string;
  buttonDisabled?: boolean;
  buttonSize?: ButtonSize;
  dataTestId?: string;
}) => {
  const [isAllowedBtn] = usePermission(permissionString);

  return (
    <EmptyState image={image} line1={line1} line2={line2} titleLine={titleLine}>
      <RestrictedTooltip
        to={permissionString}
        notAllowedTitle={notAllowedTitle}
        forceDisallowTitle={forceDisallowTitle}
      >
        <Button
          dataTestId={dataTestId}
          onClick={onClick}
          disabled={!isAllowedBtn || buttonDisabled}
          size={buttonSize ?? 'medium'}
        >
          Get started
        </Button>
      </RestrictedTooltip>
    </EmptyState>
  );
};

export default EmptyStateWithButton;
